export class AutoSweepConstant {
    public static AS_MANAGEMENT_FEE: number = 0.2;
}